export default __webpack_public_path__ + "static/media/under_construction.a0775cb2.svg";